import React from 'react';

const Video = (props: React.SVGProps<SVGSVGElement>) => {
  return (
    <div className="flex items-center justify-center rounded-full bg-[rgba(27,31,77,0.40)] backdrop-blur-[8px]">
      <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
          d="M19.0375 11.4218C21.688 13.0698 23.0133 13.8938 23.3776 14.9932C23.5942 15.6468 23.5942 16.3528 23.3776 17.0064C23.0133 18.1058 21.688 18.9298 19.0375 20.5778C16.1156 22.3945 14.6546 23.3029 13.4533 23.0944C12.7415 22.9709 12.0925 22.6102 11.6118 22.071C10.8004 21.1608 10.8004 19.4405 10.8004 15.9998C10.8004 12.5591 10.8004 10.8388 11.6118 9.92864C12.0925 9.38941 12.7415 9.0287 13.4533 8.90519C14.6546 8.69672 16.1156 9.60509 19.0375 11.4218Z"
          fill="white"
        />
      </svg>
    </div>
  );
};

export default Video;
